module.exports = __webpack_public_path__ + "img/bnb.1aa88810.svg";